import { FC, useState } from 'react';

import { Col, Row } from 'antd';
import { Dropdown, Icon } from 'ui';

import { ExtraTermsType } from 'services/events/evetns.api.type';

import s from '../ExtraTC.module.scss';

interface ExtraTCItemProps {
  handleDeleteItem: (id: string) => void;
  setEditExtraTC: (extraTC: ExtraTermsType) => void;
  extraTC: ExtraTermsType;
  id: string;
}

const DROPDOWN_ITEMS = [
  { key: 'edit', label: <div className={s.dropdownItem}>Edit</div> },
  { key: 'delete', label: <div className={s.dropdownItem}>Delete</div> },
];

const ExtraTCItem: FC<ExtraTCItemProps> = ({ handleDeleteItem, id, extraTC, setEditExtraTC }) => {
  const [openedDropdown, setOpenedDropdown] = useState(false);

  const handleClickDropdownItems = (event: { key: string }, id: string) => {
    if (event.key === 'delete') {
      setOpenedDropdown(false);
      handleDeleteItem(id);
    }

    if (event.key === 'edit') {
      setOpenedDropdown(false);
      setEditExtraTC(extraTC);
    }
  };
  return (
    <Row
      gutter={[0, 8]}
      style={{ paddingLeft: 24, paddingRight: 24, paddingTop: 16, paddingBottom: 16 }}>
      <Col xs={8} sm={16}>
        {extraTC?.message}
      </Col>
      <Col xs={4} sm={3}>
        {extraTC?.showOnTicket ? 'Yes' : 'No'}
      </Col>
      <Col xs={4} sm={2}>
        {extraTC?.isRequired ? 'Yes' : 'No'}
      </Col>
      <Col xs={4} sm={2}>
        {extraTC?.disabled ? 'Yes' : 'No'}
      </Col>
      <Col xs={4} sm={1}>
        <Dropdown
          items={DROPDOWN_ITEMS}
          placement="bottomRight"
          handleItemClick={(event) => handleClickDropdownItems(event, id as string)}
          open={openedDropdown}
          onOpenChange={setOpenedDropdown}>
          <div className={s.dropdownButton}>
            <Icon name="verticalDots" color="#7d7da2" />
          </div>
        </Dropdown>
      </Col>
    </Row>
  );
};

export default ExtraTCItem;
